import { render, staticRenderFns } from "./product_page.vue?vue&type=template&id=5f1c3d4a&"
import script from "./product_page.vue?vue&type=script&lang=js&"
export * from "./product_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports